import { render, staticRenderFns } from "./ReportTotaleCertificati.vue?vue&type=template&id=60b7ac2a"
import script from "./ReportTotaleCertificati.vue?vue&type=script&lang=js"
export * from "./ReportTotaleCertificati.vue?vue&type=script&lang=js"
import style0 from "./ReportTotaleCertificati.vue?vue&type=style&index=0&id=60b7ac2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports